import {gql} from 'apollo-angular';
import { ConnectedDeviceAppVersions, ConnectedDeviceSetting } from '../../entities/connectedDeviceSetting/connectedDeviceSetting';

export const UPDATE_CONNECTED_DEVICE_SETTING = gql`
mutation updateConnectedDeviceSetting($input: ConnectedDeviceSettingInput){
  updateConnectedDeviceSetting(input: $input)
}
`;

export const UPDATE_CONNECTED_DEVICE_SETTINGS = gql`
mutation updateConnectedDeviceSettings($inputs: [ConnectedDeviceSettingInput]){
  updateConnectedDeviceSettings(inputs: $inputs)
}
`;

export const GET_CONNECTED_DEVICE_SETTING = gql`
query getConnectedDeviceSetting($key: String) {
  getConnectedDeviceSetting(key: $key) {
    key
    value
  }
}
`;

export interface GetConnectedDeviceSettingResponse {
  getConnectedDeviceSetting: ConnectedDeviceSetting;
  loading: boolean;
}

export const GET_CONNECTED_DEVICE_SETTINGS = gql`
query getConnectedDeviceSettings($keys: [String]) {
  getConnectedDeviceSettings(keys: $keys) {
    key
    value
  }
}
`;

export interface GetConnectedDeviceSettingsResponse {
  getConnectedDeviceSettinsg: ConnectedDeviceSetting[];
  loading: boolean;
}

export const GET_APP_VERSIONS = gql`
query getAppVersions($platform: ConnectedDevicePlatform) {
  getAppVersions(platform: $platform) {
    latestAppVersion
    minAppVersion
  }
}
`;

export interface GetAppVersionsResponse {
  getAppVersions: ConnectedDeviceAppVersions;
  loading: boolean;
}

